import { render, staticRenderFns } from "./CoinNetworkPlan.vue?vue&type=template&id=d5064298&scoped=true&"
import script from "./CoinNetworkPlan.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkPlan.vue?vue&type=style&index=0&id=d5064298&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5064298",
  null
  
)

export default component.exports